import { render } from "./PartnerBooking.vue?vue&type=template&id=a012a468&scoped=true"
import script from "./PartnerBooking.vue?vue&type=script&lang=js"
export * from "./PartnerBooking.vue?vue&type=script&lang=js"

import "./PartnerBooking.vue?vue&type=style&index=0&id=a012a468&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a012a468"]])

export default __exports__